/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { MultiProcessOfferDto } from '../models';
// @ts-ignore
import type { MultiProcessOfferGroupCreationRequestDto } from '../models';
// @ts-ignore
import type { MultiProcessOfferGroupCreationResponseDto } from '../models';
// @ts-ignore
import type { MultiProcessOfferGroupUpdateRequestDto } from '../models';
// @ts-ignore
import type { MultiProcessOfferGroupUpdateStatusRequestDto } from '../models';
// @ts-ignore
import type { MultiProcessOfferPrintInfoDto } from '../models';
// @ts-ignore
import type { OnUpdateMultiProcessOfferBeforePrintDataDto } from '../models';
/**
 * RestMultiProcessOffersApi - axios parameter creator
 */
export const RestMultiProcessOffersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create multi process offer
         * @param {string} userId 
         * @param {string} processId 
         * @param {MultiProcessOfferGroupCreationRequestDto} multiProcessOfferGroupCreationRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMultiProcessOffer: async (userId: string, processId: string, multiProcessOfferGroupCreationRequestDto: MultiProcessOfferGroupCreationRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('createMultiProcessOffer', 'userId', userId)
            // verify required parameter 'processId' is not null or undefined
            assertParamExists('createMultiProcessOffer', 'processId', processId)
            // verify required parameter 'multiProcessOfferGroupCreationRequestDto' is not null or undefined
            assertParamExists('createMultiProcessOffer', 'multiProcessOfferGroupCreationRequestDto', multiProcessOfferGroupCreationRequestDto)
            const localVarPath = `/api/processes/{processId}/offer-groups`
                .replace('{processId}', encodeURIComponent(String(processId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(multiProcessOfferGroupCreationRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get multi process offer by id
         * @param {string} userId 
         * @param {string} processId 
         * @param {string} multiProcessOfferGroupId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMultiProcessOfferById: async (userId: string, processId: string, multiProcessOfferGroupId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getMultiProcessOfferById', 'userId', userId)
            // verify required parameter 'processId' is not null or undefined
            assertParamExists('getMultiProcessOfferById', 'processId', processId)
            // verify required parameter 'multiProcessOfferGroupId' is not null or undefined
            assertParamExists('getMultiProcessOfferById', 'multiProcessOfferGroupId', multiProcessOfferGroupId)
            const localVarPath = `/api/processes/{processId}/offer-groups/{multiProcessOfferGroupId}`
                .replace('{processId}', encodeURIComponent(String(processId)))
                .replace('{multiProcessOfferGroupId}', encodeURIComponent(String(multiProcessOfferGroupId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get multi process offer print
         * @param {string} userId 
         * @param {string} processId 
         * @param {string} multiProcessOfferGroupId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMultiProcessOfferPrintInfo: async (userId: string, processId: string, multiProcessOfferGroupId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getMultiProcessOfferPrintInfo', 'userId', userId)
            // verify required parameter 'processId' is not null or undefined
            assertParamExists('getMultiProcessOfferPrintInfo', 'processId', processId)
            // verify required parameter 'multiProcessOfferGroupId' is not null or undefined
            assertParamExists('getMultiProcessOfferPrintInfo', 'multiProcessOfferGroupId', multiProcessOfferGroupId)
            const localVarPath = `/api/processes/{processId}/offers-groups/{multiProcessOfferGroupId}/print`
                .replace('{processId}', encodeURIComponent(String(processId)))
                .replace('{multiProcessOfferGroupId}', encodeURIComponent(String(multiProcessOfferGroupId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get multi process offers
         * @param {string} userId 
         * @param {string} processId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMultiProcessOffers: async (userId: string, processId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getMultiProcessOffers', 'userId', userId)
            // verify required parameter 'processId' is not null or undefined
            assertParamExists('getMultiProcessOffers', 'processId', processId)
            const localVarPath = `/api/processes/{processId}/offer-groups`
                .replace('{processId}', encodeURIComponent(String(processId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update multi process offer before print data
         * @param {string} userId 
         * @param {string} processId 
         * @param {string} multiProcessOfferGroupId 
         * @param {OnUpdateMultiProcessOfferBeforePrintDataDto} onUpdateMultiProcessOfferBeforePrintDataDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        onPrintMultiProcessOfferUpdate: async (userId: string, processId: string, multiProcessOfferGroupId: string, onUpdateMultiProcessOfferBeforePrintDataDto: OnUpdateMultiProcessOfferBeforePrintDataDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('onPrintMultiProcessOfferUpdate', 'userId', userId)
            // verify required parameter 'processId' is not null or undefined
            assertParamExists('onPrintMultiProcessOfferUpdate', 'processId', processId)
            // verify required parameter 'multiProcessOfferGroupId' is not null or undefined
            assertParamExists('onPrintMultiProcessOfferUpdate', 'multiProcessOfferGroupId', multiProcessOfferGroupId)
            // verify required parameter 'onUpdateMultiProcessOfferBeforePrintDataDto' is not null or undefined
            assertParamExists('onPrintMultiProcessOfferUpdate', 'onUpdateMultiProcessOfferBeforePrintDataDto', onUpdateMultiProcessOfferBeforePrintDataDto)
            const localVarPath = `/api/processes/{processId}/offers-groups/{multiProcessOfferGroupId}/print`
                .replace('{processId}', encodeURIComponent(String(processId)))
                .replace('{multiProcessOfferGroupId}', encodeURIComponent(String(multiProcessOfferGroupId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(onUpdateMultiProcessOfferBeforePrintDataDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update multi process offer
         * @param {string} userId 
         * @param {string} processId 
         * @param {string} multiProcessOfferGroupId 
         * @param {MultiProcessOfferGroupUpdateRequestDto} multiProcessOfferGroupUpdateRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMultiProcessOffer: async (userId: string, processId: string, multiProcessOfferGroupId: string, multiProcessOfferGroupUpdateRequestDto: MultiProcessOfferGroupUpdateRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('updateMultiProcessOffer', 'userId', userId)
            // verify required parameter 'processId' is not null or undefined
            assertParamExists('updateMultiProcessOffer', 'processId', processId)
            // verify required parameter 'multiProcessOfferGroupId' is not null or undefined
            assertParamExists('updateMultiProcessOffer', 'multiProcessOfferGroupId', multiProcessOfferGroupId)
            // verify required parameter 'multiProcessOfferGroupUpdateRequestDto' is not null or undefined
            assertParamExists('updateMultiProcessOffer', 'multiProcessOfferGroupUpdateRequestDto', multiProcessOfferGroupUpdateRequestDto)
            const localVarPath = `/api/processes/{processId}/offer-groups/{multiProcessOfferGroupId}`
                .replace('{processId}', encodeURIComponent(String(processId)))
                .replace('{multiProcessOfferGroupId}', encodeURIComponent(String(multiProcessOfferGroupId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(multiProcessOfferGroupUpdateRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update multi process offer status
         * @param {string} userId 
         * @param {string} processId 
         * @param {string} multiProcessOfferGroupId 
         * @param {MultiProcessOfferGroupUpdateStatusRequestDto} multiProcessOfferGroupUpdateStatusRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMultiProcessOfferStatus: async (userId: string, processId: string, multiProcessOfferGroupId: string, multiProcessOfferGroupUpdateStatusRequestDto: MultiProcessOfferGroupUpdateStatusRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('updateMultiProcessOfferStatus', 'userId', userId)
            // verify required parameter 'processId' is not null or undefined
            assertParamExists('updateMultiProcessOfferStatus', 'processId', processId)
            // verify required parameter 'multiProcessOfferGroupId' is not null or undefined
            assertParamExists('updateMultiProcessOfferStatus', 'multiProcessOfferGroupId', multiProcessOfferGroupId)
            // verify required parameter 'multiProcessOfferGroupUpdateStatusRequestDto' is not null or undefined
            assertParamExists('updateMultiProcessOfferStatus', 'multiProcessOfferGroupUpdateStatusRequestDto', multiProcessOfferGroupUpdateStatusRequestDto)
            const localVarPath = `/api/processes/{processId}/offer-groups/{multiProcessOfferGroupId}/status`
                .replace('{processId}', encodeURIComponent(String(processId)))
                .replace('{multiProcessOfferGroupId}', encodeURIComponent(String(multiProcessOfferGroupId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(multiProcessOfferGroupUpdateStatusRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RestMultiProcessOffersApi - functional programming interface
 */
export const RestMultiProcessOffersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RestMultiProcessOffersApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create multi process offer
         * @param {string} userId 
         * @param {string} processId 
         * @param {MultiProcessOfferGroupCreationRequestDto} multiProcessOfferGroupCreationRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createMultiProcessOffer(userId: string, processId: string, multiProcessOfferGroupCreationRequestDto: MultiProcessOfferGroupCreationRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MultiProcessOfferGroupCreationResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createMultiProcessOffer(userId, processId, multiProcessOfferGroupCreationRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestMultiProcessOffersApi.createMultiProcessOffer']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get multi process offer by id
         * @param {string} userId 
         * @param {string} processId 
         * @param {string} multiProcessOfferGroupId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMultiProcessOfferById(userId: string, processId: string, multiProcessOfferGroupId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MultiProcessOfferDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMultiProcessOfferById(userId, processId, multiProcessOfferGroupId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestMultiProcessOffersApi.getMultiProcessOfferById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get multi process offer print
         * @param {string} userId 
         * @param {string} processId 
         * @param {string} multiProcessOfferGroupId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMultiProcessOfferPrintInfo(userId: string, processId: string, multiProcessOfferGroupId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MultiProcessOfferPrintInfoDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMultiProcessOfferPrintInfo(userId, processId, multiProcessOfferGroupId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestMultiProcessOffersApi.getMultiProcessOfferPrintInfo']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get multi process offers
         * @param {string} userId 
         * @param {string} processId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMultiProcessOffers(userId: string, processId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<MultiProcessOfferDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMultiProcessOffers(userId, processId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestMultiProcessOffersApi.getMultiProcessOffers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update multi process offer before print data
         * @param {string} userId 
         * @param {string} processId 
         * @param {string} multiProcessOfferGroupId 
         * @param {OnUpdateMultiProcessOfferBeforePrintDataDto} onUpdateMultiProcessOfferBeforePrintDataDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async onPrintMultiProcessOfferUpdate(userId: string, processId: string, multiProcessOfferGroupId: string, onUpdateMultiProcessOfferBeforePrintDataDto: OnUpdateMultiProcessOfferBeforePrintDataDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.onPrintMultiProcessOfferUpdate(userId, processId, multiProcessOfferGroupId, onUpdateMultiProcessOfferBeforePrintDataDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestMultiProcessOffersApi.onPrintMultiProcessOfferUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update multi process offer
         * @param {string} userId 
         * @param {string} processId 
         * @param {string} multiProcessOfferGroupId 
         * @param {MultiProcessOfferGroupUpdateRequestDto} multiProcessOfferGroupUpdateRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateMultiProcessOffer(userId: string, processId: string, multiProcessOfferGroupId: string, multiProcessOfferGroupUpdateRequestDto: MultiProcessOfferGroupUpdateRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateMultiProcessOffer(userId, processId, multiProcessOfferGroupId, multiProcessOfferGroupUpdateRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestMultiProcessOffersApi.updateMultiProcessOffer']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update multi process offer status
         * @param {string} userId 
         * @param {string} processId 
         * @param {string} multiProcessOfferGroupId 
         * @param {MultiProcessOfferGroupUpdateStatusRequestDto} multiProcessOfferGroupUpdateStatusRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateMultiProcessOfferStatus(userId: string, processId: string, multiProcessOfferGroupId: string, multiProcessOfferGroupUpdateStatusRequestDto: MultiProcessOfferGroupUpdateStatusRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateMultiProcessOfferStatus(userId, processId, multiProcessOfferGroupId, multiProcessOfferGroupUpdateStatusRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestMultiProcessOffersApi.updateMultiProcessOfferStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * RestMultiProcessOffersApi - factory interface
 */
export const RestMultiProcessOffersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RestMultiProcessOffersApiFp(configuration)
    return {
        /**
         * 
         * @summary Create multi process offer
         * @param {string} userId 
         * @param {string} processId 
         * @param {MultiProcessOfferGroupCreationRequestDto} multiProcessOfferGroupCreationRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMultiProcessOffer(userId: string, processId: string, multiProcessOfferGroupCreationRequestDto: MultiProcessOfferGroupCreationRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<MultiProcessOfferGroupCreationResponseDto> {
            return localVarFp.createMultiProcessOffer(userId, processId, multiProcessOfferGroupCreationRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get multi process offer by id
         * @param {string} userId 
         * @param {string} processId 
         * @param {string} multiProcessOfferGroupId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMultiProcessOfferById(userId: string, processId: string, multiProcessOfferGroupId: string, options?: RawAxiosRequestConfig): AxiosPromise<MultiProcessOfferDto> {
            return localVarFp.getMultiProcessOfferById(userId, processId, multiProcessOfferGroupId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get multi process offer print
         * @param {string} userId 
         * @param {string} processId 
         * @param {string} multiProcessOfferGroupId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMultiProcessOfferPrintInfo(userId: string, processId: string, multiProcessOfferGroupId: string, options?: RawAxiosRequestConfig): AxiosPromise<MultiProcessOfferPrintInfoDto> {
            return localVarFp.getMultiProcessOfferPrintInfo(userId, processId, multiProcessOfferGroupId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get multi process offers
         * @param {string} userId 
         * @param {string} processId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMultiProcessOffers(userId: string, processId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<MultiProcessOfferDto>> {
            return localVarFp.getMultiProcessOffers(userId, processId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update multi process offer before print data
         * @param {string} userId 
         * @param {string} processId 
         * @param {string} multiProcessOfferGroupId 
         * @param {OnUpdateMultiProcessOfferBeforePrintDataDto} onUpdateMultiProcessOfferBeforePrintDataDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        onPrintMultiProcessOfferUpdate(userId: string, processId: string, multiProcessOfferGroupId: string, onUpdateMultiProcessOfferBeforePrintDataDto: OnUpdateMultiProcessOfferBeforePrintDataDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.onPrintMultiProcessOfferUpdate(userId, processId, multiProcessOfferGroupId, onUpdateMultiProcessOfferBeforePrintDataDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update multi process offer
         * @param {string} userId 
         * @param {string} processId 
         * @param {string} multiProcessOfferGroupId 
         * @param {MultiProcessOfferGroupUpdateRequestDto} multiProcessOfferGroupUpdateRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMultiProcessOffer(userId: string, processId: string, multiProcessOfferGroupId: string, multiProcessOfferGroupUpdateRequestDto: MultiProcessOfferGroupUpdateRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateMultiProcessOffer(userId, processId, multiProcessOfferGroupId, multiProcessOfferGroupUpdateRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update multi process offer status
         * @param {string} userId 
         * @param {string} processId 
         * @param {string} multiProcessOfferGroupId 
         * @param {MultiProcessOfferGroupUpdateStatusRequestDto} multiProcessOfferGroupUpdateStatusRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMultiProcessOfferStatus(userId: string, processId: string, multiProcessOfferGroupId: string, multiProcessOfferGroupUpdateStatusRequestDto: MultiProcessOfferGroupUpdateStatusRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateMultiProcessOfferStatus(userId, processId, multiProcessOfferGroupId, multiProcessOfferGroupUpdateStatusRequestDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RestMultiProcessOffersApi - interface
 */
export interface RestMultiProcessOffersApiInterface {
    /**
     * 
     * @summary Create multi process offer
     * @param {string} userId 
     * @param {string} processId 
     * @param {MultiProcessOfferGroupCreationRequestDto} multiProcessOfferGroupCreationRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createMultiProcessOffer(userId: string, processId: string, multiProcessOfferGroupCreationRequestDto: MultiProcessOfferGroupCreationRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<MultiProcessOfferGroupCreationResponseDto>;

    /**
     * 
     * @summary Get multi process offer by id
     * @param {string} userId 
     * @param {string} processId 
     * @param {string} multiProcessOfferGroupId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getMultiProcessOfferById(userId: string, processId: string, multiProcessOfferGroupId: string, options?: RawAxiosRequestConfig): AxiosPromise<MultiProcessOfferDto>;

    /**
     * 
     * @summary Get multi process offer print
     * @param {string} userId 
     * @param {string} processId 
     * @param {string} multiProcessOfferGroupId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getMultiProcessOfferPrintInfo(userId: string, processId: string, multiProcessOfferGroupId: string, options?: RawAxiosRequestConfig): AxiosPromise<MultiProcessOfferPrintInfoDto>;

    /**
     * 
     * @summary Get multi process offers
     * @param {string} userId 
     * @param {string} processId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getMultiProcessOffers(userId: string, processId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<MultiProcessOfferDto>>;

    /**
     * 
     * @summary Update multi process offer before print data
     * @param {string} userId 
     * @param {string} processId 
     * @param {string} multiProcessOfferGroupId 
     * @param {OnUpdateMultiProcessOfferBeforePrintDataDto} onUpdateMultiProcessOfferBeforePrintDataDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    onPrintMultiProcessOfferUpdate(userId: string, processId: string, multiProcessOfferGroupId: string, onUpdateMultiProcessOfferBeforePrintDataDto: OnUpdateMultiProcessOfferBeforePrintDataDto, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Update multi process offer
     * @param {string} userId 
     * @param {string} processId 
     * @param {string} multiProcessOfferGroupId 
     * @param {MultiProcessOfferGroupUpdateRequestDto} multiProcessOfferGroupUpdateRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateMultiProcessOffer(userId: string, processId: string, multiProcessOfferGroupId: string, multiProcessOfferGroupUpdateRequestDto: MultiProcessOfferGroupUpdateRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Update multi process offer status
     * @param {string} userId 
     * @param {string} processId 
     * @param {string} multiProcessOfferGroupId 
     * @param {MultiProcessOfferGroupUpdateStatusRequestDto} multiProcessOfferGroupUpdateStatusRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateMultiProcessOfferStatus(userId: string, processId: string, multiProcessOfferGroupId: string, multiProcessOfferGroupUpdateStatusRequestDto: MultiProcessOfferGroupUpdateStatusRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void>;

}

/**
 * RestMultiProcessOffersApi - object-oriented interface
 */
export class RestMultiProcessOffersApi extends BaseAPI implements RestMultiProcessOffersApiInterface {
    /**
     * 
     * @summary Create multi process offer
     * @param {string} userId 
     * @param {string} processId 
     * @param {MultiProcessOfferGroupCreationRequestDto} multiProcessOfferGroupCreationRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createMultiProcessOffer(userId: string, processId: string, multiProcessOfferGroupCreationRequestDto: MultiProcessOfferGroupCreationRequestDto, options?: RawAxiosRequestConfig) {
        return RestMultiProcessOffersApiFp(this.configuration).createMultiProcessOffer(userId, processId, multiProcessOfferGroupCreationRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get multi process offer by id
     * @param {string} userId 
     * @param {string} processId 
     * @param {string} multiProcessOfferGroupId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getMultiProcessOfferById(userId: string, processId: string, multiProcessOfferGroupId: string, options?: RawAxiosRequestConfig) {
        return RestMultiProcessOffersApiFp(this.configuration).getMultiProcessOfferById(userId, processId, multiProcessOfferGroupId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get multi process offer print
     * @param {string} userId 
     * @param {string} processId 
     * @param {string} multiProcessOfferGroupId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getMultiProcessOfferPrintInfo(userId: string, processId: string, multiProcessOfferGroupId: string, options?: RawAxiosRequestConfig) {
        return RestMultiProcessOffersApiFp(this.configuration).getMultiProcessOfferPrintInfo(userId, processId, multiProcessOfferGroupId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get multi process offers
     * @param {string} userId 
     * @param {string} processId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getMultiProcessOffers(userId: string, processId: string, options?: RawAxiosRequestConfig) {
        return RestMultiProcessOffersApiFp(this.configuration).getMultiProcessOffers(userId, processId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update multi process offer before print data
     * @param {string} userId 
     * @param {string} processId 
     * @param {string} multiProcessOfferGroupId 
     * @param {OnUpdateMultiProcessOfferBeforePrintDataDto} onUpdateMultiProcessOfferBeforePrintDataDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public onPrintMultiProcessOfferUpdate(userId: string, processId: string, multiProcessOfferGroupId: string, onUpdateMultiProcessOfferBeforePrintDataDto: OnUpdateMultiProcessOfferBeforePrintDataDto, options?: RawAxiosRequestConfig) {
        return RestMultiProcessOffersApiFp(this.configuration).onPrintMultiProcessOfferUpdate(userId, processId, multiProcessOfferGroupId, onUpdateMultiProcessOfferBeforePrintDataDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update multi process offer
     * @param {string} userId 
     * @param {string} processId 
     * @param {string} multiProcessOfferGroupId 
     * @param {MultiProcessOfferGroupUpdateRequestDto} multiProcessOfferGroupUpdateRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateMultiProcessOffer(userId: string, processId: string, multiProcessOfferGroupId: string, multiProcessOfferGroupUpdateRequestDto: MultiProcessOfferGroupUpdateRequestDto, options?: RawAxiosRequestConfig) {
        return RestMultiProcessOffersApiFp(this.configuration).updateMultiProcessOffer(userId, processId, multiProcessOfferGroupId, multiProcessOfferGroupUpdateRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update multi process offer status
     * @param {string} userId 
     * @param {string} processId 
     * @param {string} multiProcessOfferGroupId 
     * @param {MultiProcessOfferGroupUpdateStatusRequestDto} multiProcessOfferGroupUpdateStatusRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateMultiProcessOfferStatus(userId: string, processId: string, multiProcessOfferGroupId: string, multiProcessOfferGroupUpdateStatusRequestDto: MultiProcessOfferGroupUpdateStatusRequestDto, options?: RawAxiosRequestConfig) {
        return RestMultiProcessOffersApiFp(this.configuration).updateMultiProcessOfferStatus(userId, processId, multiProcessOfferGroupId, multiProcessOfferGroupUpdateStatusRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
}

